import {vpost} from "@/util/post";

export const role = {

    listAll: async () => {
        return (await vpost("/access/allRole")).data;
    },
    saveRole(id, name, desc) {
        let formData1 = new FormData();
        formData1.append("id", id);
        formData1.append("name", name);
        formData1.append("desc", desc);
        return vpost("/access/saveRole", formData1);
    },
    getDetail(id) {
        return vpost("/access/getRoleDetail?id=" + id);
    },
    async listAccess() {
        return (await vpost("access/listAccess")).data;
    },
    async listRoleAccess(roleId) {
        return (await vpost("access/listRoleAccess?roleId=" + roleId)).data;
    },
    updateRoleAccess(roleId, checkAccess) {
        let dto = {
            roleId: roleId,
            accessCode: checkAccess
        };

        return vpost("/access/updateRoleAccess", dto);
    },
    deleteRole(id) {
        return vpost("/access/deleteRole?id=" + id);
    }
}
